import React, { useEffect } from 'react';
import { useTranslation } from '@lt/localization';
import type { ReactNode } from 'react';
import styles from './sendCodeAgainTimer.module.css';
import { ActionItem } from '../ActionItem';

type Props = {
  onSendCode?: () => void;
  timeLeftToDeliver: number;
  SubmitComponent?: ReactNode;
  timer?: NodeJS.Timeout;
};

export const SendCodeAgainTimer = ({
  onSendCode,
  timeLeftToDeliver,
  SubmitComponent,
  timer,
}: Props) => {
  const { t } = useTranslation();

  useEffect(
    () => () => {
      if (timer) {
        clearInterval(timer);
      }
    },
    [],
  );

  return (
    <>
      {timeLeftToDeliver > 0 && (
        <div className={styles.timer}>
          {t('checkout.sendCode.timer', { time: timeLeftToDeliver })}
        </div>
      )}
      {timeLeftToDeliver < 1 &&
        (SubmitComponent || (
          <ActionItem className={styles.actionItem} onClick={onSendCode}>
            {t('checkout.sendCode.button')}
          </ActionItem>
        ))}
    </>
  );
};
